import { HealthAndSafety, Settings } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";

import { ManagePlans } from "./ManagePlans";
import { useHealthPlanContractContext } from "@/contexts/HealthPlanContractContext";
import { useViewContext } from "@/contexts/ViewContext";
import { currentFeatures } from "@/configs/Settings";

export function useManagePlans() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();
  const { contractHealthPlan } = useHealthPlanContractContext();

  const configs: IFeatures = {
    active:
      access?.type === "professional" &&
      currentFeatures.managePlans &&
      contractHealthPlan &&
      (availableRoles?.includes("manager") ||
        availableRoles?.includes("owner")),
    path: "/manageplans",
    icon: Settings,
    text: "Gerenciar operadoras",

    subitem: true,
    parent: "Planos de saúde",

    sideMenu: true,
    sideMenuIndex: 0,

    component: () => <ManagePlans />,
  };

  return configs;
}
